<span>
  <div class="attribute" *ngFor="let attribute of attributes">
    <span class="name">{{ attribute.name }}:</span>
    <span class="value">{{ attribute.value }}</span>
  </div>
</span>
